import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { preferences, refreshAuth } from './state'
import './styles.css'

document.documentElement.classList.toggle('reduce-motion', preferences.reducedMotion)

async function bootstrap() {
  // Restore the HTTP-only server session before Vue Router evaluates a
  // protected destination. Without this, a page refresh looked like a logout.
  await refreshAuth()
  createApp(App).use(router).mount('#app')
}

void bootstrap()
